import React from 'react';
import { PropTypes } from 'prop-types';
import { Pie } from 'react-chartjs-2';

const KWHPIE = (props) => {
    const {
        annualResults, annualKWH, doughnutSlider, annualMonth, totalkWhs,
    } = props;

    let consumption = 0;
    if (annualMonth === true) {
        consumption = annualKWH;
    } else {
        consumption = totalkWhs;
    }

    const doughYears = doughnutSlider;
    const year1SolarkWh = annualResults[doughYears].systemProduction;
    const year1RemainingUtilitykWh =
        consumption - annualResults[doughYears].systemProduction > 0
            ? consumption - annualResults[doughYears].systemProduction
            : 0;

    const kWhComparisonPie = {
        datasets: [
            {
                data: [year1RemainingUtilitykWh.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'), year1SolarkWh.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')],
                backgroundColor: ['#db4141', '#61ff9a'],
                defaultFontSize: 20,
            },
        ],
        labels: ['Utility kWh', 'Solar kWh'],
    };

    return (
        <li>
            <Pie height={300} data={kWhComparisonPie} options={{ maintainAspectRatio: true }} />
        </li>
    );
};
KWHPIE.propTypes = {
    annualResults: PropTypes.object.isRequired,
    annualKWH: PropTypes.number.isRequired,
    doughnutSlider: PropTypes.number.isRequired,
    annualMonth: PropTypes.bool.isRequired,
    totalkWhs: PropTypes.number.isRequired,
};

export default KWHPIE;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/Graphs/KWHPIE/KWHPIE.js